import PathologyFields from '../not-donor/pathology-fields';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
import templateOnly from "@ember/component/template-only";
const MyComponent = setComponentTemplate(precompileTemplate("\n  <PathologyFields @form={{@form}} />\n", {
  strictMode: true,
  scope: () => ({
    PathologyFields
  })
}), templateOnly(undefined, "pathology-fields:MyComponent"));
export default MyComponent;